import dark from '../../assets/paystreet_logo_dark.png';
import white from '../../assets/paystreet_logo_white.png';

/** docs/06 §1: white logo on dark surfaces, dark logo on white. Minimum width 96 px. */
export function Logo({ variant = 'white', className = 'h-6 w-auto' }: { variant?: 'white' | 'dark'; className?: string }) {
  return <img src={variant === 'white' ? white : dark} alt="PayStreet" className={className} />;
}
